import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18nMap from 'src/mapping/i18nMap.json';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from 'src/pages/Log/shared';
import { getServiceNamesByValues } from 'src/utils/service';
import { formatTableCounts, replaceTableData } from 'src/utils/table';

import { ThreatType } from '../../../../utils/enums';
import Percent from '../../Charts/Percent';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function getBackendValue(data: string, valueMap: Map<string, string>) {
  let result = data;
  if (valueMap.has(data)) {
    result = valueMap.get(data) as string;
  }
  return result;
}

function SecurityRiskPhishingDetection(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '12%', grow: 1, align: 'right' },
    { width: '12%', grow: 1, align: 'right' },
    { width: '10%', grow: 1, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.detectedBy'),
    t(`dashboard.chart.column.last${props.day}`),
    t(`dashboard.chart.column.prev${props.day}`),
    t('dashboard.chart.column.change'),
  ];

  const phishingDetectionMap = new Map<string, string>(
    Object.entries(i18nMap['phishingDetection'].frontendMap)
  );
  const phishingBackendMap = new Map<string, string>(
    Object.entries(i18nMap['phishingDetection'].backendMap)
  );

  const data = formatTableCounts(
    props.data?.securityRiskScanPhishingDetectedBy?.[props.day],
    props.data?.securityRiskScanPhishingDetectedByPrevious?.[props.day]
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.WebReputation],
              type: 'terms',
            },
            {
              field: 'threatType',
              values: [ThreatType.Phishing],
              type: 'terms',
            },
            {
              field: 'urlCategory',
              values: ['75'],
              type: 'terms',
            },
            {
              field: 'malwareDetectedBy',
              // values: [row[0] as string],
              values: [getBackendValue(row[0], phishingBackendMap)],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    <Percent n={row[row.length - 1]} />,
  ]);

  replaceTableData(data, phishingDetectionMap, 0, t);

  return (
    <DashboardCard title={t('dashboard.chart.title.atpPhishingDetection')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskPhishingDetection);
